import { Languages } from "lucide-react";
import { setLanguage, t, type UiLanguage } from "../i18n";
import { useLanguage } from "../useLanguage";

export function LanguageSelector({ compact = false, hideLabel = false }: { compact?: boolean; hideLabel?: boolean }) {
  const language = useLanguage();
  return (
    <label className={compact ? "language-selector" : "field language-selector"}>
      <span className={hideLabel ? "sr-only" : undefined}><Languages size={18} aria-hidden="true" /> {t("Γλώσσα")}</span>
      <select value={language} onChange={event => setLanguage(event.target.value as UiLanguage)} aria-label={t("Γλώσσα εφαρμογής")}>
        <option value="el" lang="el">Ελληνικά</option>
        <option value="en" lang="en">English</option>
      </select>
    </label>
  );
}
